import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetch_user_profile,
  update_user_profile,
  upload_avatar,
  type UpdateUserProfileInput,
  type UserProfile,
} from './api';

const USER_PROFILE_KEY = ['user', 'profile'] as const;

export function use_user_profile() {
  return useQuery({
    queryKey: USER_PROFILE_KEY,
    queryFn: fetch_user_profile,
    staleTime: 0,
    retry: 0,
  });
}

export function use_update_user_profile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateUserProfileInput) => update_user_profile(input),
    onSuccess: (data: UserProfile) => {
      qc.setQueryData(USER_PROFILE_KEY, data);
    },
  });
}

export function use_upload_avatar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => upload_avatar(file),
    onSuccess: (data: UserProfile) => {
      qc.setQueryData(USER_PROFILE_KEY, data);
      // The avatar bytes changed — drop any cached blob for the file path.
      if (data.avatar_url) qc.invalidateQueries({ queryKey: ['file-blob', data.avatar_url] });
    },
  });
}
